"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * reef REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.XYZCoordToJSON = exports.XYZCoordFromJSONTyped = exports.XYZCoordFromJSON = void 0;
function XYZCoordFromJSON(json) {
    return XYZCoordFromJSONTyped(json, false);
}
exports.XYZCoordFromJSON = XYZCoordFromJSON;
function XYZCoordFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'x': json['x'],
        'y': json['y'],
        'z': json['z'],
    };
}
exports.XYZCoordFromJSONTyped = XYZCoordFromJSONTyped;
function XYZCoordToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'x': value.x,
        'y': value.y,
        'z': value.z,
    };
}
exports.XYZCoordToJSON = XYZCoordToJSON;
